<template>
  <ims-modal
    :title="$store.state.interact.modals.joinLeague.title"
    :canClose="true"
    :show="$store.state.interact.modals.joinLeague.show"
    :onClose="close"
  >
    <template v-slot:header>
      <ims-toolbar size="md" class="px-1">
        <nav class="ims-tabs inverse">
          <ims-button
            :class="`tab ${view == 'public' ? 'active' : ''}`"
            @click="showPublic()"
          >Public</ims-button>
          <ims-button
            :class="`tab ${view == 'private' ? 'active' : ''}`"
            @click="showPrivate()"
          >Private</ims-button>
        </nav>
      </ims-toolbar>
    </template>
    <main>
      <public-leagues v-if="view == 'public'" />
      <private-league v-if="view == 'private'" />
    </main>
  </ims-modal>
</template>

<script>
import PublicLeagues from "./public-leagues.vue";
import PrivateLeague from "./private-league.vue";

export default {
  components: {
    PublicLeagues,
    PrivateLeague
  },
  data() {
    return {
      view: "public"
    };
  },
  methods: {
    close() {
      this.$store.commit("modals/joinLeague", null);
    },
    showPublic() {
      this.view = "public";
    },
    showPrivate() {
      this.view = "private";
    }
  }
};
</script>

<style lang="scss">
</style>